import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  Fragment,
} from 'react'
import injectStyles from 'react-jss'
import { useSelector } from 'react-redux'

import { styles } from './styles'
import Breadcrumbs from '../../Breadcrumps'
import BreadcrumbsHomeSvg from '../../../../../Assets/Images/icons/breadcrumbsHome'
import { useParams } from 'react-router-dom'
import { PATHS } from '../../../../../Config/Routing/paths'
import LoadingIndicator from '../../../../../Components/LoadingIndicator/LoadingIndicator'
import { getRejectedCampaign } from './gql'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'
import { authorization } from '../../../../../Module/Auth/Auth'
import StatusLabelSelfServe from '../../../../../Components/StatusLabelSelfServe'
import { CAMPAIGN_INTERNAL_STATUSES } from '../../../../../shared/constants'
import SimpleButton from '../../SimpleButton'
import {
  addAuthParamsToCampaignBuilderUrl,
  getCampaignBuilderPageUrl,
} from '../../../../Country/Page/Pipeline/PipelineView/utils'
import { openLinkInNewTab } from '../../../../Campaigns/Page/InternalFiles/Container/utils'
import { HtmlToReact } from '../../../utils'
import { updateCampaignsCampaignBuilderData } from '../../../../Campaigns/Page/InternalFiles/Container/graphQL'
import useSmallScreen from '../../../../../Components/ClientDashboard/Components/CampaignCard/useSmallScreen'

const RejectedCampaign = ({ classes }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [campaign, setCampaign] = useState(null)
  const smallScreen = useSmallScreen()
  const currentClient = useSelector(state => state.clients.clientView)
  const canNavigateCampaignBuilder =
    !authorization.isClient() ||
    (currentClient && currentClient.isSelfServeEnabled)

  const user = authorization.getUser()
  const clientId = user.client.id

  const { campaignId } = useParams()

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getRejectedCampaign,
    defaultFetchArgs: {
      campaignId,
      clientId,
    },
    mapResponse: data =>
      data.campaignsBuilderData &&
      data.campaignsBuilderData.nodes &&
      data.campaignsBuilderData.nodes[0],
  })

  useEffect(() => {
    setIsLoading(true)
    if (isLoaded) {
      setCampaign(data)
      setIsLoading(false)
    }
  }, [isLoaded])

  const breadcrumbs = useMemo(() => {
    const acc = [
      {
        text: 'Home',
        to: `${PATHS.dashboard.dashboard}${PATHS.dashboard.home}`,
      },
    ]
    if (campaign) {
      acc.push({
        text: campaign.campaignName,
      })
    }
    return acc
  }, [campaign])

  const handleEditCampaign = useCallback(async () => {
    await updateCampaignsCampaignBuilderData({
      input: {
        campaignId,
        internalStatus: CAMPAIGN_INTERNAL_STATUSES.DRAFT,
      },
    })

    const campaignBuilderPageUrl = getCampaignBuilderPageUrl({
      campaignId,
      clientId,
      lastActiveStep: campaign.lastActiveStep,
      channel: campaign.type,
      subtype: campaign.subtype,
    })

    const url = addAuthParamsToCampaignBuilderUrl(
      campaignBuilderPageUrl,
      clientId,
    )
    openLinkInNewTab(url)
  }, [campaign])

  const email = useMemo(() => {
    return (
      campaign &&
      campaign.declineCampaignEmail &&
      HtmlToReact(campaign.declineCampaignEmail)
    )
  }, [campaign])

  return (
    <div className={classes.root}>
      {!smallScreen && (
        <Breadcrumbs icon={<BreadcrumbsHomeSvg />} breadcrumbs={breadcrumbs} />
      )}
      {isLoading ? (
        <div className={classes.loadingWrapper}>
          <LoadingIndicator label={'Loading'} />
        </div>
      ) : (
        <div className={classes.main}>
          <div className={classes.titleWrap}>
            <div className={classes.title} cypress_id={'campaignNameTitle'}>
              {campaign.campaignName}
            </div>
            {!smallScreen && (
              <StatusLabelSelfServe
                status={CAMPAIGN_INTERNAL_STATUSES.DRAFT}
                isDeclined={true}
                cypress_id={'campaignStatus'}
              />
            )}
          </div>
          <div
            className={classes.subtitle}
            cypress_id={'reasonIfDeclinedWithoutEmail'}
          >
            We apologize, but your campaign has been declined. For further
            assistance, please reach out to our customer success team.
          </div>
          {email ? (
            <Fragment>
              <div
                className={classes.reasons}
                cypress_id={'reasonsIfDeclinedWithEmail'}
              >
                Reasons:
              </div>
              <div className={classes.text}>{email}</div>
            </Fragment>
          ) : (
            <div className={classes.text} />
          )}
          {canNavigateCampaignBuilder && (
            <div className={classes.wrapperButton}>
              <SimpleButton
                label="Edit campaign"
                onClick={handleEditCampaign}
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(RejectedCampaign)
